import {
  AfterContentInit,
  Component,
  ContentChildren,
  forwardRef,
  HostBinding,
  Input,
  NgZone,
  QueryList,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { merge, Subscription } from 'rxjs';

import { PgRadioButtonComponent } from './pg-radio-button.component';

@Component({
  selector: 'pg-radio-group, grit-radio-group',
  templateUrl: './pg-radio-group.component.html',
  styleUrls: ['./pg-radio-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PgRadioGroupComponent),
      multi: true,
    },
  ],
})
export class PgRadioGroupComponent
  implements AfterContentInit, ControlValueAccessor {
  private _disabled: boolean = false;

  @Input('disabled')
  @HostBinding('class.disabled')
  get disabled(): boolean {
    return this._disabled;
  }

  set disabled(value) {
    this._disabled = value;
    if (this._disabled) {
      this.disableAllRadioButtons();
    } else {
      this.enableAllRadioButtons();
    }
  }

  @ContentChildren(PgRadioButtonComponent)
  _childButtons: QueryList<PgRadioButtonComponent>;

  subs: Subscription[] = [];
  private _childClickSubscription: Subscription;
  value: any;

  onChange = _ => {};
  onTouch = _ => {};

  constructor(private _ngZone: NgZone) {}

  ngAfterContentInit() {
    this._subscribeToChildClickEvents();
    this._setSelectedChild();
  }

  disableAllRadioButtons() {
    this._ngZone.runOutsideAngular(() =>
      setTimeout(() => {
        if (this._childButtons && this._childButtons.length) {
          this._childButtons.forEach((radio: PgRadioButtonComponent) => {
            radio.disabled = true;
          });
        }
      })
    );
  }
  enableAllRadioButtons() {
    this._ngZone.runOutsideAngular(() =>
      setTimeout(() => {
        if (this._childButtons && this._childButtons.length) {
          this._childButtons.forEach((radio: PgRadioButtonComponent) => {
            radio.disabled = false;
          });
        }
      })
    );
  }

  private _setSelectedChild() {
    if (this.value || this.value === 0) {
      const child = this._getChildWithValue(this.value);
      if (child) {
        child.selected = true;
      }
    }
  }
  private _unselectAllChildren() {
    if (this._childButtons && this._childButtons.length) {
      this._childButtons.forEach(child => (child.selected = false));
    }
  }

  private _getChildWithValue(val) {
    if (this._childButtons && this._childButtons.length) {
      return this._childButtons.find(c => c.value === val);
    }
  }

  private _subscribeToChildClickEvents() {
    if (this._childClickSubscription && !this._childClickSubscription.closed) {
      this._childClickSubscription.unsubscribe();
    }

    this._childClickSubscription = merge(
      ...this._childButtons.map(cb => cb.click)
    ).subscribe((ref: PgRadioButtonComponent) => {
      this.writeValue(ref.value);
    });
  }

  writeValue(obj: any): void {
    if (obj !== this.value) {
      this.value = obj;
      this._unselectAllChildren();
      const child = this._getChildWithValue(obj);
      if (child) {
        child.selected = true;
      }
      this.onChange(this.value);
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}
}
